/*
  PDP specs drawer tabs (Features / Product Info / Directions, or merchant tab
  blocks). Implements the WAI-ARIA Tabs pattern: roving tabindex, arrow-key
  navigation (with Home/End), aria-selected, and tab/tabpanel wiring. Panel
  visibility is driven by data-active (CSS shows the active panel, display:none
  the rest), so inactive panels are also hidden from assistive tech.
*/
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.c-pdp-specs-drawer').forEach(setupDrawer);
    document.addEventListener('click', handleClick);
  }

  function tabsIn(root) {
    return Array.from(root.querySelectorAll('[role="tab"][data-tab]'));
  }

  function panelsIn(root) {
    return Array.from(root.querySelectorAll('[data-panel]'));
  }

  /* Wire tab <-> panel relationships. Idempotent: the default-tabs path already
     sets ids/roles in Liquid; the merchant-block path may not, so fill any gaps. */
  function setupDrawer(root) {
    const tabs = tabsIn(root);
    if (tabs.length === 0) return;
    const panels = panelsIn(root);

    tabs.forEach(function (tab) {
      const slug = tab.dataset.tab;
      if (!tab.id) tab.id = 'pdp-tab-' + slug;
      const panel = panels.find(function (p) { return p.dataset.panel === slug; });
      if (panel) {
        if (!panel.id) panel.id = 'pdp-panel-' + slug;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '0');
        tab.setAttribute('aria-controls', panel.id);
      }
    });

    const active = root.querySelector('[data-tab][data-active="true"]') || tabs[0];
    selectTab(root, active.dataset.tab, false);

    root.addEventListener('keydown', function (event) {
      onKeydown(root, event);
    });
  }

  function selectTab(root, slug, moveFocus) {
    tabsIn(root).forEach(function (tab) {
      const on = tab.dataset.tab === slug;
      tab.dataset.active = on ? 'true' : 'false';
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
      if (on && moveFocus) tab.focus();
    });
    panelsIn(root).forEach(function (panel) {
      panel.dataset.active = panel.dataset.panel === slug ? 'true' : 'false';
    });
  }

  function onKeydown(root, event) {
    const tab = event.target.closest('[role="tab"][data-tab]');
    if (!tab) return;

    /* Only visible tabs participate (a tab whose source data is empty is not
       rendered, but guard anyway). */
    const tabs = tabsIn(root).filter(function (t) { return t.offsetParent !== null; });
    const i = tabs.indexOf(tab);
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = tabs[(i + 1) % tabs.length];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = tabs[(i - 1 + tabs.length) % tabs.length];
        break;
      case 'Home':
        next = tabs[0];
        break;
      case 'End':
        next = tabs[tabs.length - 1];
        break;
      case 'Enter':
      case ' ':
      case 'Spacebar':
        selectTab(root, tab.dataset.tab, false);
        event.preventDefault();
        return;
      default:
        return;
    }

    if (next) {
      selectTab(root, next.dataset.tab, true);
      event.preventDefault();
    }
  }

  function handleClick(event) {
    const tab = event.target.closest('[role="tab"][data-tab]');
    if (!tab) return;
    const root = tab.closest('.c-pdp-specs-drawer');
    if (!root) return;
    selectTab(root, tab.dataset.tab, false);
    event.preventDefault();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
